export default __webpack_public_path__ + "static/og-fb-4df1b50ad56b106dca6505afe48ccdb0.png";